// removed by extract-text-webpack-plugin
module.exports = {"Logo":"_19WaN2tuJCY7yX7kGD_ZBx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 108
// module chunks = 0